var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDownloaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.5C6.34315 0.5 5 1.84315 5 3.5V23.5C5 25.1569 6.34315 26.5 8 26.5H18C19.6569 26.5 21 25.1569 21 23.5V3.5C21 1.84315 19.6569 0.5 18 0.5H8ZM19 4.5H7V22.5H19V4.5Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14L12 16L16.5 11.5",
    stroke: "#B08C3D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDownloaded);
export default __webpack_public_path__ + "static/media/mobile-downloaded.7ce1bc5bf0f663e71018fa17e9e5d3d2.svg";
export { ForwardRef as ReactComponent };